import React, { Component } from 'react';
import { RESTExecutor, withDomains } from '../../lib/domain';
import { Select, Row, Button, Divider, Table, message, Popconfirm } from 'antd';
import Title from 'antd/lib/typography/Title';
import { showErrorInNotification, formatMoney } from '../../lib/util';


const participant_cols = ({ onRemove }) => [
  {
    title: "Username",
    dataIndex: '__references__',
    key: 'username',
    render: (ref = {}) => {
      let user=ref.user_id||{}
      return user.username
    }
  },
  {
    title: "Name",
    dataIndex: '__references__',
    key: 'name',
    render: (ref = {}) => {
      let user=ref.user_id||{}
      return user.name
    }
  },
  {
    title: "Email",
    dataIndex: '__references__',
    key: 'email',
    render: (ref = {}) => {
      let user=ref.user_id||{}
      return user.email
    }
  },
  {
    title: "",
    dataIndex: 'id',
    key: 'id',
    render: (id) => {
      return <Popconfirm title={"Are you sure you want to remove this participant for the report?"} onConfirm={()=>{
        typeof onRemove === 'function' && onRemove(id)
      }}> <Button type='link' style={{ color: 'red' }}>Remove</Button>
      </Popconfirm>
    }
  }
]
class ReportParticipants extends Component {
  constructor(props) {
    super(props)

    this.state = {
    }

    this.list_users = RESTExecutor.list().config({
      label: 'user_list'
    }).connect(props.domains.reports);


    this.list_participants = RESTExecutor.list().config({
      label: 'participants'
    }).connect(props.domains.reports);

    this.assign_user = RESTExecutor.post().config({
      label: 'participants'
    }).callbacks((success) => {
      message.success("User Assigned Successfully");
      this.list_participants.execute();
      this.setState({selected_user_id:null})


    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.reports);


    this.remove_participant = RESTExecutor.delete().config({
      label: 'participants_detail',
      params: {
        config_id: "",
        participant_id: ""
      }
    }).callbacks((success) => {
      message.success("User removed");
      this.list_participants.execute();
    }, (error) => {
      showErrorInNotification(error);
    }).connect(props.domains.reports);

    this.list_users.execute();
    this.list_participants.forId(this.props.report_id).execute();

  }

  assignUser = (id) => {
    this.assign_user.forId(this.props.report_id).execute({ user_id: this.state.selected_user_id })
  }

  render() {
    let list_users_resp = this.list_users.response();
    let list_participants_resp = this.list_participants.response();

    let user_list = (list_users_resp.result && list_users_resp.result.rows) || [];

    let rowsData = (list_participants_resp.result && list_participants_resp.result.rows) || [];
    let rowsMeta = list_participants_resp.meta || {};


    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column'
      }}>
        <Title type='secondary' level={3}>Assign New User</Title>


        <Row type='flex' style={{ flexWrap: 'nowrap' }}>
          <Select
            style={{ width: '100%' }}
            placeholder={"Search user to assign"}
            value={this.state.selected_user_id}
            showSearch
            filterOption={false}
            loading={list_users_resp.fetching}
            onSearch={(value) => {
              this.list_users.config({
                params: {
                  query: value
                }
              }).execute();
            }}
            allowClear
            onChange={(value) => {
              this.setState({
                selected_user_id: value
              })
            }}

          >
            {user_list.map((item) => {
              return <Select.Option value={item.id} key={item.id}>
                {item.name}
              </Select.Option>
            })}
          </Select>
          <Button onClick={() => {
            this.assignUser()
          }} type='primary' style={{ marginLeft: 12 }} disabled={!this.state.selected_user_id}>Assign</Button>
        </Row>

        <Divider />
        <Title type='secondary' 
        level={3}>Assigned Users</Title>
        <Table
        scroll={{x:true}}
        className='main-table'
        size='small'
          dataSource={rowsData}
          loading={list_participants_resp.fetching}
          pagination={{
            simple: false,
                            position:'bottom',
            onChange: (current, size) => {
              this.list_participants.config({
                params: {
                  per_page: size,
                  page: current
                }
              }).execute();
            },
            defaultCurrent: 1,
            current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
            pageSize: (rowsMeta && rowsMeta.requested_count),

            total: (rowsMeta && rowsMeta.total_count),
            showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
          }}
          columns={participant_cols({
            onRemove: (id) => {
              this.remove_participant.config({
                params: {
                  config_id: this.props.report_id,
                  participant_id: id
                }
              }).execute()
            }
          })}
        />


      </div>
    );
  }
}

export default withDomains(ReportParticipants, "reports");
